export default __webpack_public_path__ + "static/media/card-to-card-info-icon-3.0a7ad6cb.svg";